(function () {
  'use strict';

  // Brücke zwischen unseren AJAX-Zugängen und der Warenkorb-Lade des Themes.
  //
  // pf-script.js (Kaufbox) und pf-recs.js (Empfehlungskarten) melden einen
  // erfolgreichen Zugang über die Events 'cart:updated' / 'cart:refresh'.
  // Diese Events kennt das Pursuit-Theme jedoch nicht: es rendert den Warenkorb
  // ausschließlich über theme.Cart.prototype._onProductAdded() neu — genau das
  // tut auch theme.AddItemToCart nach seinem eigenen /cart/add.js.
  //
  // Ohne diesen Aufruf landet der Artikel zwar im Warenkorb, aber Zähler und
  // Lade aktualisieren sich erst beim nächsten Seitenaufbau. _onProductAdded
  // rendert den Warenkorb neu und öffnet die Lade (bei Warenkorb-Typ „Seite"
  // springt es stattdessen auf /cart).
  //
  // Dazu kommen drei Dinge für die Lade selbst (snippets/cart-drawer.liquid):
  //   PFCart.open()   öffnet sie; der Warenkorb-Knopf im Kopf ruft das auf
  //   Escape          schließt sie
  //   [data-pfc-add]  die Knöpfe „Dazu“ bei den Empfehlungen

  var last = 0;

  function refresh(force) {
    var now = Date.now();
    if (!force && now - last < 400) return; // beide Events kommen unmittelbar nacheinander
    last = now;
    try {
      if (window.theme && theme.Cart && theme.Cart.prototype &&
          typeof theme.Cart.prototype._onProductAdded === 'function') {
        theme.Cart.prototype._onProductAdded();
      }
    } catch (e) {
      // Der Artikel ist im Warenkorb; nur die Anzeige bliebe dann stehen.
    }
  }

  document.addEventListener('cart:updated', function () { refresh(false); });
  document.addEventListener('cart:refresh', function () { refresh(false); });

  /* ── Lade öffnen und schließen ─────────────────────────────────────── */
  function lade() { return document.getElementById('sidebar-cart'); }

  function open() {
    var el = lade();
    if (!el) return false;
    // Die Methode des Themes setzt zusätzlich die Fokusfalle. Sie greift
    // nicht auf die Instanz zu, deshalb geht der Aufruf über den Prototyp.
    try {
      if (window.theme && theme.Cart && typeof theme.Cart.prototype._sidebarDrawerOpen === 'function') {
        theme.Cart.prototype._sidebarDrawerOpen();
        return true;
      }
    } catch (e) { /* dann eben von Hand */ }
    el.classList.add('show');
    document.body.classList.add('show_overlay');
    el.focus();
    return true;
  }

  function close() {
    var el = lade();
    if (!el || !el.classList.contains('show')) return;
    el.classList.remove('show');
    document.body.classList.remove('show_overlay');
    var knopf = document.getElementById('HeaderCart');
    if (knopf && el.contains(document.activeElement)) knopf.focus();
  }

  window.PFCart = { open: open, close: close, refresh: function () { refresh(true); } };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* ── „Dazu“ bei den Empfehlungen ───────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('[data-pfc-add]') : null;
    if (!knopf) return;
    e.preventDefault();
    if (knopf.disabled) return;

    var id = parseInt(knopf.getAttribute('data-pfc-add'), 10);
    if (!id) return;
    knopf.disabled = true;

    var url = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { refresh(true); })
      .catch(function () {
        knopf.disabled = false;
        var text = knopf.querySelector('span');
        if (text) text.textContent = 'Nicht verfügbar';
      });
  });
})();
